import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './valePedagioPeriodoForm';

import { setModoTela, initForm, salvar, excluir, getLista } from './valePedagioPeriodoActions';
import DateFormat from '../common/dateFormat/DateFormat';

class ValePedagioPeriodo extends Component {

	state = {
		linhaSelecionada: null
	}

    componentWillMount() {
        this.props.getLista();
    }

    render() {
        return (
            <div>
                <Content>
					{this.props.modoTela == 'cadastro' ? (
						<Form onSubmit={this.props.salvar} />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form excluir onSubmit={this.props.excluir} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </div>
        )
    }

	lista() {
		return (
			<ContentCard>
				<ContentCardHeader>
					<Row>
						<Grid cols='6 6 4 2'>
							<Button
								text='Abrir Novo Período'
								type={'success'}
								icon={'fa fa-plus'}
								event={() => {
									this.props.setModoTela('cadastro', {
										datahora_abertura: DateFormat.formatarDataHoraSqlParaTela(DateFormat.getDataHoraAtual())
									});
									this.props.initForm({
										datahora_abertura: DateFormat.formatarDataHoraSqlParaTela(DateFormat.getDataHoraAtual())
									});
								}} />
						</Grid>
					</Row>
				</ContentCardHeader>
				<ContentCardBody>
					<Table responsive>
						<THead>
							<Tr>
								<Th>Abertura</Th>
								<Th>Fechamento</Th>
								<Th></Th>
							</Tr>
						</THead>
						<TBody>
							{(this.props.lista).map(item => (
								<Tr key={item.id} className={`${this.state.linhaSelecionada == item.id ? 'hover' : ''}`}
									onClick={() => this.setState({ ...this.state, linhaSelecionada: item.id })}
									onMouseEnter={() => this.setState({ ...this.state, linhaSelecionada: item.id })} >
									<Td>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_abertura)}</Td>
									<Td>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_fechamento)}</Td>
									<Td alignRight minWidth={100}>
										<ButtonTable
											type={'warning'}
											icon={'fas fa-pencil-alt'}
											visible={this.state.linhaSelecionada == item.id}
											event={() => {
												this.props.setModoTela('cadastro', {
													...item,
													datahora_abertura: DateFormat.formatarDataHoraSqlParaTela(item.datahora_abertura),
													datahora_fechamento: DateFormat.formatarDataHoraSqlParaTela(item.datahora_fechamento)
												});
												this.props.initForm({
													...item,
													datahora_abertura: DateFormat.formatarDataHoraSqlParaTela(item.datahora_abertura),
													datahora_fechamento: DateFormat.formatarDataHoraSqlParaTela(item.datahora_fechamento)
												});
											}} />

										{!item.datahora_fechamento &&
										<ButtonTable
											type={'danger'}
											icon={'fas fa-trash-alt'}
											visible={this.state.linhaSelecionada == item.id}
											title={'Realizar Exclusão'}
											event={() => {
												this.props.excluir(item);
											}} />}
									</Td>
								</Tr>
							))}
						</TBody>
					</Table>
				</ContentCardBody>
			</ContentCard>
		);
	}


}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	modoTela: state.valePedagioPeriodo.modoTela,
	lista: state.valePedagioPeriodo.lista
});
const mapDispatchToProps = dispatch => bindActionCreators({ setModoTela, initForm, salvar, excluir, getLista }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(ValePedagioPeriodo);
